import React, { useEffect } from "react";
import keycloak from "../lib/keycloak";

const SSOLogin: React.FC = () => {

    useEffect(() => {

        const startLogin = async () => {
            try {
                await keycloak.init({
                    onLoad: "login-required",
                    checkLoginIframe: false,
                    pkceMethod: "S256",
                    redirectUri: `${window.location.origin}/sso-callback`
                });
            } catch (error) {
                console.error("Keycloak init failed:", error);
            }
        };

        startLogin();

    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <h3>Redirecting to login...</h3>
        </div>
    );
};

export default SSOLogin;
